const serverUrl = 'http://my-reader-api.herokuapp.com';

module.exports = serverUrl;